import Component from '../core/Component'
import { queryAll, toggleClass, triggerEvent } from '../utils/dom'

const STATES = {
    OPEN: 'is-open',
    CHECKED: 'is-checked',
    DISABLED: 'is-disabled'
}

export default class Select extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            select: null,
            list: null,
            value: null
        }
    }

    prepare() {
        this.ref.list.innerHTML = Array.from(this.ref.select.options)
            .map(option => ({
                text: option.textContent,
                value: option.value,
                disabled: option.disabled
            }))
            .map(item => `
                <div class="Select-item" data-value="${item.value}">
                    <div class="Select-checkbox"></div>
                    <div class="Select-label">${item.text}</div>
                </div>
            `.trim())
            .join('\n')

        const selectOptions = Object.fromEntries(Array.from(this.ref.select.options)
            .map(element => [element.value, element]))

        this.items = Object.fromEntries(queryAll('[data-value]', this.ref.list)
            .map(item => [item.dataset.value, {
                element: item,
                label: item.textContent.trim(),
                checked: false,
                option: selectOptions[item.dataset.value],
                disabled: selectOptions[item.dataset.value].disabled
            }]))

        queryAll('option[selected]', this.ref.select)
            .forEach(item => this.items[item.value].checked = true)

        this.ref.value.addEventListener('click', this.handleValueClick)
        this.ref.list.addEventListener('click', this.handleListClick)

        this.render()
    }

    destroy() {
        document.removeEventListener('click', this.handleOuterClick)
    }

    handleValueClick = event => {
        this.toggle()
    }

    handleListClick = event => {
        const item = event.target.closest('[data-value]')

        if (!item) {
            return
        }

        this.toggleItem(item.dataset.value)
    }

    handleOuterClick = event => {
        if (!this.element.contains(event.target)) {
            this.close()
        }
    }

    toggle() {
        if (this.is(STATES.OPEN)) {
            this.close()
        } else {
            this.open()
        }
    }

    open() {
        if (this.is(STATES.DISABLED)) {
            return
        }

        this.element.classList.add(STATES.OPEN)
        triggerEvent(this.element, 'select:open')
        document.addEventListener('click', this.handleOuterClick)
    }

    close() {
        this.element.classList.remove(STATES.OPEN)
        triggerEvent(this.element, 'select:close')
        document.removeEventListener('click', this.handleOuterClick)
    }

    toggleItem(value) {
        let changed = false

        if (value && this.items[value].disabled) {
            return
        }

        if (value === '') {
            Object.keys(this.items)
                .filter(key => key)
                .forEach(key => this.items[key].checked = false)

            if (!this.items[value].checked) {
                this.items[value].checked = true
                changed = true
            }
        } else {
            this.items[value].checked = !this.items[value].checked
            changed = true
        }

        if (value !== '' && this.items[value].checked) {
            this.items[''].checked = false
        }

        const checked = Object.keys(this.items)
            .filter(key => this.items[key].checked)

        if (checked.length === 0) {
            this.items[''].checked = true
            changed = true
        }

        this.render()

        if (changed) {
            triggerEvent(this.ref.select, 'change')
        }
    }

    render() {
        const keys = Object.keys(this.items)
        keys.forEach(key => {
            const { element, checked, option, disabled } = this.items[key]
            toggleClass(element, STATES.DISABLED, disabled)
            toggleClass(element, STATES.CHECKED, checked)
            option.selected = checked
        })

        const disabled = keys.filter(key => this.items[key].disabled)

        toggleClass(this.element, STATES.DISABLED, disabled.length === keys.length - 1)

        this.ref.value.textContent = Object.keys(this.items)
            .filter(key => this.items[key].checked)
            .map(key => this.items[key].label)
            .join(', ')
    }
}
